export default "__VITE_ASSET__DR0Xi8ug__"